angular.module('unica_notification.notification_services')

.factory('NotificationSendService', function($http, getBaseApiURL) {

	var notificationSendService = {};

	notificationSendService.send = function( notificationGroupId) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/notification-group/send/' + notificationGroupId ,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});
	};

	return notificationSendService;

});